import { render } from "./IronOwlDesigns.vue?vue&type=template&id=2ac6e404"
import script from "./IronOwlDesigns.vue?vue&type=script&lang=js"
export * from "./IronOwlDesigns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__